import { createSlice, isAction } from "@reduxjs/toolkit";
import {
  fetchSacCodeById,
  fetchSacCodes,
  updateSacCode,
  updateStatusInSacCode,
} from "./thunk";

interface SACCodeState {
  sacCodeList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedSACCode: any;
}

const initialState: SACCodeState = {
  sacCodeList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedSACCode: null,
};

const sacCodeSlice = createSlice({
  name: "sacCode",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSacCodes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSacCodes.fulfilled, (state, action) => {
        state.loading = false;
        state.sacCodeList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchSacCodes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch SAC codes";
      })
      .addCase(fetchSacCodeById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSacCodeById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedSACCode = action.payload;
      })
      .addCase(fetchSacCodeById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updateSacCode.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.sacCodeList = state.sacCodeList.map((code) =>
          code.id === action.payload.id ? action.payload : code
        );
      })
      .addCase(updateSacCode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update SAC code";
      })
      .addCase(updateStatusInSacCode.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.sacCodeList = state.sacCodeList.map((code) =>
          code.id === action.payload.id ? action.payload : code
        );
      })
      .addCase(updateStatusInSacCode.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to update SAC code status";
      });
  },
});

export default sacCodeSlice.reducer;
